import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

export interface ProductVariant {
  no: string;
  color: string;
  size: string;
  smallImageUrl: string;
}

const fetchItemVariants = (itemNo: string) => {
  return httpClient.tasks.get<ProductVariant[]>(
    `/items/item-variants?itemNo=${itemNo}`
  );
};

export const useItemVariants = (itemNo: string) => {
  return useQuery({
    queryKey: ["item", "variants", itemNo],
    queryFn: () => fetchItemVariants(itemNo),
    enabled: !!itemNo,
    refetchOnWindowFocus: false,
    staleTime: 86400000,
  });
};
